/**
 * Route gate that redirects to /login when the user is not
 * authenticated. Wraps the workspace shell.
 */

import { type ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export function AuthGate({ children }: { children: ReactNode }) {
  const { loading, principal } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="auth-loading" role="status">
        Loading...
      </div>
    );
  }

  if (principal === null) {
    return (
      <Navigate
        to="/login"
        replace
        // Carry the original target so the login page can hand
        // the user back where they came from.
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return <>{children}</>;
}
